import {
  useEvents
} from "./chunk-TFRVQL75.mjs";
import {
  HelpCenterEvents
} from "./chunk-AOTFDLGI.mjs";

// src/internal/components/help-center-panel/help-center-handler-close-event.tsx
import { useEffect } from "react";
import { useAnalytics } from "@clara/events";
import { Fragment, jsx } from "react/jsx-runtime";
var HelpCenterHandlerCloseEvent = ({
  children
}) => {
  const analytics = useAnalytics();
  const { eventData } = useEvents();
  useEffect(() => {
    var _a, _b;
    const closeEvent = () => {
      analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_CLOSE, {
        ...eventData,
        action: "close"
      });
    };
    (_a = document.querySelector("button#drawer-close-button")) == null ? void 0 : _a.addEventListener("click", closeEvent);
    (_b = document.querySelector("div.MuiBackdrop-root.MuiModal-backdrop")) == null ? void 0 : _b.addEventListener("click", closeEvent);
    return () => {
      var _a2, _b2;
      (_a2 = document.querySelector("button#drawer-close-button")) == null ? void 0 : _a2.removeEventListener("click", closeEvent);
      (_b2 = document.querySelector("div.MuiBackdrop-root.MuiModal-backdrop")) == null ? void 0 : _b2.removeEventListener("click", closeEvent);
    };
  }, [analytics, eventData]);
  return /* @__PURE__ */ jsx(Fragment, { children });
};

export {
  HelpCenterHandlerCloseEvent
};
